<template>
  <div class="header-container" :class="{'top-header-container-remove-radius' : contentPosition === -250}">
    <div class="top-header-container">
      <BackButton :clickMethod="back" class="mb-3"/>

      <h4>
        {{$tI('Advanced reports')}} <strong>| {{$tI('Genetic Similarities Breakdown')}}</strong>
        <span @click="GeneticSimilaritiesInfoModal.showModal = true" class="open-info-modal-btn"
          v-click-track="'Iframe.ancientDnaGeneticSimilaritiesReportTooltipClicked'">
          <InfoIcon />
        </span>
      </h4>
      <p class="description">
        {{ description[$store.state.geneticSimilarities.selectedOrigin] }}
      </p>
    </div>

    <div class="tab-container">
      <div 
        v-for="(tab, index) in tabs" 
        :key="tab.Id" 
        :class="[
          'tab', { active: tab.Id === $store.state.geneticSimilarities.selectedOrigin },
          { 'single': tab.Id === 'SINGLE' }]"
        @click="selectTab(tab.Id, index)"
      >
        {{ $t(tab.name) }}
      </div>
    </div>

    <GeneticSimilaritiesInfoModal v-if="GeneticSimilaritiesInfoModal.showModal" :modalObject="GeneticSimilaritiesInfoModal"/>
  </div>

</template>

<script>
import BackButton from '@/components/ui/BackButton.vue';
import InfoIcon from '@/components/icons/InfoIcon.vue';
import GeneticSimilaritiesInfoModal from './Modals/GeneticSimilaritiesInfoModal.vue';

export default {
  components: {
    BackButton,
    InfoIcon,
    GeneticSimilaritiesInfoModal,
  },
  props: {
    contentPosition: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      GeneticSimilaritiesInfoModal: {
        showModal: false,
      },

      description: {
        'DUAL': this.$tI_YO_G('Dual origin subtitle'),
        'TRIPLE': this.$tI_YO_G('Triple origin subtitle'),
      },

      tabs: [
        { name: this.$tI('Tab title Dual origin'), Id: 'DUAL' },
        { name: this.$tI('Tab title Triple origin'), Id: 'TRIPLE' },
      ],
      underlineStyle: {
        width: '0px',
        left: '0px',
        backgroundColor: '#BB4ECE',
      }
    };
  },
  methods: {
    selectTab(Id, index) {
      this.$store.state.geneticSimilarities.selectedOrigin = Id;

      // Update the underline position and color based on the selected tab
      this.$nextTick(() => {
        const activeTabElement = this.$el.querySelectorAll('.tab')[index];
        this.underlineStyle = {
          width: `${activeTabElement.offsetWidth}px`,
          left: `${activeTabElement.offsetLeft}px`,
          backgroundColor: '#BB4ECE'
        };
      });
    },

    back() {
      this.$router.push({ name: 'dashboard' });
    },
  },
  mounted() {
    this.$store.state.geneticSimilarities.selectedOrigin = 'DUAL'
    this.selectTab(this.$store.state.geneticSimilarities.selectedOrigin, 0);
  }
};
</script>

<style lang="scss" scoped>
.header-container {
  background-color: var(--white-100);
  .mobile-header-icon {
    margin-bottom: -28px;
    margin-top: 0;
  }
}

.top-header-container {
  padding: 28px 28px 0 28px;
}

@media screen and (max-width: 769px) {
  .tab {
    font-size: 1rem !important;
  }
}
</style>